<template>
  <div class="dialog-wrap" v-show="isConfirmDialogShow">
    <div class="cover"></div>
    <div class="confirm-dialog">
      <div class="header">温馨提示</div>
      <div class="content">
        <div v-for="(item, index) in content" :key="index">{{ item }}</div>
      </div>
      <div class="footer">
        <div class="btn" @click="isConfirmDialogShow = false">取消</div>
        <div class="btn btn1" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  data() {
    return {
      isConfirmDialogShow: false,
    };
  },
  methods: {
    open() {
      this.isConfirmDialogShow = true;
    },
    confirm() {
      this.$emit("confirmDialog", this.content);
      this.isConfirmDialogShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
}
.cover {
  position: absolute;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.4);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  z-index: 998;
}
.confirm-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2.8rem;
  background: #ffffff;
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  padding: 0.24rem 0;
  .header {
    font-size: 0.16rem;
    margin-top: 0.24rem;
  }
  .content {
    margin: 0.2rem 0 0.3rem;
    line-height: 0.2rem;
    text-align: center;
  }
  .footer {
    display: flex;
    gap: 0.16rem;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      border: 1px solid #02a8a2;
      border-radius: 0.34rem;
      color: #02a8a2;
      line-height: 0.34rem;
      text-align: center;
      cursor: pointer;
    }
    .btn1 {
      background: #02a8a2;
      color: #ffffff;
    }
  }
}
</style>
